import { Component, Prop, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import SingleCheckboxButton from "@/components/single-checkbox-button/single-checkbox-button.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import { trainingFormApi } from "@/providers/apis/training-form";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { TRAINING_APPLICATION_FORM_QUERY } from "@/graphql/training-application-form-query";
import {
  FormFieldContents,
  FormNavbar,
  TrainingForm,
} from "@/models/training-form/training-form.interface";
import TrainingPreviewFormComponent from "../training-preview-form/training-preview-form.component.vue";
import DemographicDataComponent from "../demographic-data/demographic-data.component.vue";
import { utils } from "@/utils/utils";
import moment from "moment";
import DropdownListComponent from "../dropdown-list/dropdown-list.component.vue";
import InputTagComponent from "../input-tags/input-tags.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import { loginApi } from "@/providers/apis/login";
import { appConfigService } from "@/providers/services/app/app-config";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";

@Component({
  name: "training-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-dropdown": DropdownListComponent,
    "b-form-single-checkbox": SingleCheckboxButton,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-demographic-form": DemographicDataComponent,
    "b-preview-form": TrainingPreviewFormComponent,
    "b-form-tag-input": InputTagComponent,
    "b-form-upload-file": FileUploadComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
  },
})
export default class TrainingFormComponent extends Vue {
  public formPagination = 0;
  public formName = "certificationPartOneBasicDetails";
  public applicationData: Array<TrainingForm> = [];
  public applicationNavData: FormNavbar[] = [];
  public formData: FormFieldContents[] = [];
  public isNavLoad = false;
  public isScroll = false;
  public isValid = false;
  public formDataResult: any;
  public formApplicationId = "";
  public getTrainingApplicationBasicData: any;
  public currentForm: any;
  public signatureInvalid = false;
  public saveDataDraft = false;
  public payLoadData: any = {
    fillStatus: "DRAFT",
    id: "",
    certificationPartOneBasicDetails: {
      firstName: "",
      lastName: "",
      isOtherName: "",
      allVersionNames: [],
      preferredFirstName: "",
      preferredLastName: "",
      trainingCity: [],
      otherTrainingCity: "",
      travelForThisTraining: "",
      socialSecurityNumber: "",
      gender: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: "",
      doYouPrefer: [],
      primaryPhone: "",
      email: "",
      secondaryPhone: "",
      secondaryEmail: null,
    },
    trainingEducationExperience: {
      job_or_volunteer_title_1: "",
      job_or_volunteer_agency_1: "",
      job_or_volunteer_startDate_1: "",
      job_or_volunteer_endDate_1: "",
      job_or_volunteer_title_2: "",
      job_or_volunteer_agency_2: "",
      job_or_volunteer_startDate_2: "",
      job_or_volunteer_endDate_2: "",
      highSchool: [],
      highSchoolNotListed: "",
      certificateFiles: [],
      otherCertifications: [],
      cprsCertificate: [],
      cfssCertificate: [],
      otherCertificate: [],
    },
    trainingProgrammaticEligibilityQuestions: {
      isAgeValid: "",
      mentalHealthChallenge: "",
      consecutiveMonths: "",
      substanceAbuse: "",
      wellnessYourself: "",
      weeklongTraining: "",
      comfortableParticipation: "",
    },
    trainingJourneyofHeadling: {
      shapeofYourLife: "",
      wellnessRecovery: "",
      supportSystem: "",
      selfCare: "",
      backgroundViewpoint: "",
      yourLivedExperience: "",
      advocatedForYourself: "",
      yourStrengths: "",
      taughtaGroup: "",
      greatestChallenge: "",
      anythingElse: "",
    },
    trainingSignature: {
      isSignature: "",
      submissionDate: moment().format("MM-DD-YYYY"),
      demographic: {
        hispanicorLatino: {
          hispanicorLatino: "",
        },
        ethnicGroupYourself: {
          centralAmerican: "",
          cuban: "",
          dominican: "",
          mexican: "",
          southAmerican: "",
          others: "",
        },
        raceYourself: {
          blackAmerican: "",
          asian: "",
          nativeHawaiian: "",
          pacificIslander: "",
          white: "",
          americanIndian: "",
          dob: "",
        },
      },
    },
  };
  public formTitle = {
    main_title: "",
    application_name: "",
  };
  public isLoading = true;
  public errorMessage = "";
  public formCompletedIndex: number[] = [];
  public checkValidForm = false;
  public isEdit = false;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public hideDiv: string[] = [
    "allVersionNames",
    "otherTrainingCity",
    "highSchoolNotListed",
    "cprsCertificate",
    "cfssCertificate",
    "otherCertificate",
  ];
  public checkField: string[] = [
    "isOtherName",
    "trainingCity",
    "highSchool",
    "otherCertifications",
  ];
  public additionalNames = [];
  public additionalNamesCount = 0;
  public fileData: any[] = [];
  public mainId = "app";
  public currentRoute = "";
  public isFileValid = false;
  public notFilesUploadedKeyNames: string[] = [];
  public jobVolunteerDuplicateField: string[] = [];

  constructor() {
    super();
  }

  public async created() {
    this.currentRoute = this.$route.path;
    loginApi
      .logInWithCredential(
        appConfigService.getClientId(),
        appConfigService.getClientKey(),
        "anonymous"
      )
      .then((data) => {
        this.isLoading = false;
        localStorage.setItem("anonymousToken", data.access_token);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
    this.$validator.extend(
      "tagsMaxLength",
      utils.customValidator.tagsValidation
    );
    let payloadStorage: any = localStorage.getItem("trainingFormPayload");
    const formFilledIndex: any = localStorage.getItem(
      "trainingFormFilledIndex"
    );
    if (formFilledIndex) {
      formFilledIndex.split(",").forEach((data: string) => {
        this.formCompletedIndex.push(Number(data));
      });
    }
    // Re-derive step 0 completion from a live validation so a stale mark can't
    // make the finalize gate skip an unfinished Basic Details tab.
    this.syncStepZeroOnLoad();

    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.payLoadData = { ...payloadStorage };
    }
    if (this.formPagination === 0) {
      this.isNavLoad = true;
    }
    this.$apollo
      .query({
        query: gql`query ${TRAINING_APPLICATION_FORM_QUERY}`,
      })
      .then((result) => {
        this.applicationData = result.data.trainingApplicationForms.data;
        this.formTitle = {
          main_title: this.applicationData[0].attributes.main_title,
          application_name: this.applicationData[0].attributes.application_name,
        };
        this.applicationNavData = this.applicationData[0].attributes.navbar;
        this.formData = JSON.parse(
          JSON.stringify(this.applicationData[0].attributes.form_fields)
        );
        for (let index = 0; index < this.checkField.length; index++) {
          this.fieldUpdate(this.checkField[index], true);
        }
        // Arm autosave only now: everything above is the form loading itself,
        // not the applicant filling it in.
        this.$nextTick(() => {
          this.startDraftAutoSave();
        });
      });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }
  public mounted() {
    const mainEl: any = document.querySelector(".main-content");
    if (mainEl) {
      mainEl.addEventListener("keyup", (event: any) => {
        if (event.shiftKey && event.keyCode == 9) {
          const el = event.path[0];
          if (el) {
            el.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        }
      });
    }
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }

  public formEdit(slug: any) {
    this.isEdit = true;
    this.formName = slug;
    if (slug == "certificationPartOneBasicDetails") {
      this.formPagination = 0;
    } else if (slug == "trainingEducationExperience") {
      this.formPagination = 1;
    } else if (slug == "trainingProgrammaticEligibilityQuestions") {
      this.formPagination = 2;
    } else if (slug == "trainingJourneyofHeadling") {
      this.formPagination = 3;
    } else if (slug == "trainingSignature") {
      this.payLoadData.trainingSignature.isSignature = "";
      localStorage.setItem(
        "trainingFormPayload",
        JSON.stringify(this.payLoadData)
      );
      this.formPagination = 4;
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  public jobVolunteerDuplicate(field: string, isSplice = false) {
    if (!isSplice) {
      if (this.jobVolunteerDuplicateField.length) {
        if (!this.jobVolunteerDuplicateField.includes(field)) {
          this.jobVolunteerDuplicateField.push(field);
        }
      } else {
        this.jobVolunteerDuplicateField = [field];
      }
    } else {
      if (this.jobVolunteerDuplicateField.length) {
        const idx = this.jobVolunteerDuplicateField.findIndex(
          (data: string) => {
            return data === field;
          }
        );
        if (idx > -1) {
          this.jobVolunteerDuplicateField.splice(idx, 1);
        }
      }
    }
  }

  public nextButton() {
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    // Finalizing from the signature step must not skip earlier steps.
    if (this.formPagination === 4) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1 && incomplete !== 4) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    if (this.formPagination == 1) {
      if (
        this.payLoadData.trainingEducationExperience.job_or_volunteer_title_1 &&
        this.payLoadData.trainingEducationExperience.job_or_volunteer_title_2 &&
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_title_1 ===
          this.payLoadData.trainingEducationExperience.job_or_volunteer_title_2
      ) {
        this.jobVolunteerDuplicate("job_or_volunteer_title");
      } else {
        this.jobVolunteerDuplicate("job_or_volunteer_title", true);
      }
      if (
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_agency_1 &&
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_agency_2 &&
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_agency_1 ===
          this.payLoadData.trainingEducationExperience.job_or_volunteer_agency_2
      ) {
        this.jobVolunteerDuplicate("job_or_volunteer_agency");
      } else {
        this.jobVolunteerDuplicate("job_or_volunteer_agency", true);
      }
      if (
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_startDate_1 &&
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_startDate_2 &&
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_startDate_1 ===
          this.payLoadData.trainingEducationExperience
            .job_or_volunteer_startDate_2
      ) {
        this.jobVolunteerDuplicate("job_or_volunteer_startDate");
      } else {
        this.jobVolunteerDuplicate("job_or_volunteer_startDate", true);
      }
      if (
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_endDate_1 &&
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_endDate_2 &&
        this.payLoadData.trainingEducationExperience
          .job_or_volunteer_endDate_1 ===
          this.payLoadData.trainingEducationExperience
            .job_or_volunteer_endDate_2
      ) {
        this.jobVolunteerDuplicate("job_or_volunteer_endDate");
      } else {
        this.jobVolunteerDuplicate("job_or_volunteer_endDate", true);
      }
    }
    if (this.formPagination == 4) {
      this.payLoadData.trainingSignature.submissionDate =
        moment().format("MM-DD-YYYY");
      if (this.payLoadData.trainingSignature.isSignature) {
        this.signatureInvalid = false;
      } else {
        this.checkValidForm = true;
        this.signatureInvalid = true;
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
        return;
      }
    }
    this.$validator.validateAll().then(async (validate) => {
      if (
        validate &&
        !this.notFilesUploadedKeyNames.length &&
        !this.jobVolunteerDuplicateField.length
      ) {
        // The step completed NOW, before nextPaginationUpdate() advances it.
        const completedStep = this.formPagination;
        if (
          this.payLoadData.certificationPartOneBasicDetails.secondaryEmail ===
          ""
        ) {
          this.payLoadData.certificationPartOneBasicDetails.secondaryEmail =
            null;
        }
        this.isLoading = true;
        this.checkValidForm = false;
        this.isValid = true;
        // An autosave may be pending or in flight. Drop the pending one and wait
        // for the running one, so this updates the row the autosave created
        // instead of racing it and creating a second application.
        if (this.draftAutoSaveTimer) {
          clearTimeout(this.draftAutoSaveTimer);
          this.draftAutoSaveTimer = null;
        }
        await this.waitForDraftSave();
        if (!this.payLoadData.id) {
          await trainingFormApi
            .TrainingApplicationForm(
              this.payLoadData.fillStatus,
              this.payLoadData,
              this.currentRoute.split("/")[2]
            )
            .then((result: any) => {
              this.isLoading = false;
              this.formApplicationId = result.headers.location;
              localStorage.setItem(
                "trainingApplicationId",
                this.formApplicationId
              );
              this.payLoadData.id = localStorage.getItem(
                "trainingApplicationId"
              );
              localStorage.setItem(
                "trainingFormPayload",
                JSON.stringify(this.payLoadData)
              );
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.isLoading = false;
              this.errorMessage = utils.errorMessage(error);
            });
        } else {
          const id = this.payLoadData.id;
          await trainingFormApi
            .updateTrainingForm(
              this.payLoadData,
              id,
              this.currentRoute.split("/")[2]
            )
            .then((data) => {
              this.isLoading = false;
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
          localStorage.setItem(
            "trainingFormPayload",
            JSON.stringify(this.payLoadData)
          );
          if (this.isEdit) {
            this.formPagination = 5;
          }
        }
        if (!this.formCompletedIndex.includes(completedStep)) {
          this.formCompletedIndex.push(completedStep);
        }
        this.currentForm = this.payLoadData[this.formName];
        localStorage.setItem(
          "trainingFormFilledIndex",
          this.formCompletedIndex.toString()
        );
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
      }
    });
  }

  public allFilesUploaded(event: any) {
    if (this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.splice(event, 1);
    }
  }

  public notFileUploaded(event: string) {
    if (!this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.push(event);
    }
  }

  public resetFileKey(event: boolean) {
    if (event) {
      this.notFilesUploadedKeyNames = [];
    }
  }

  private dataStepSlugs: string[] = [
    "certificationPartOneBasicDetails",
    "trainingEducationExperience",
    "trainingProgrammaticEligibilityQuestions",
    "trainingJourneyofHeadling",
    "trainingSignature",
  ];

  private firstIncompleteDataStep(): number {
    for (let i = 0; i < this.dataStepSlugs.length; i++) {
      if (!this.formCompletedIndex.includes(i)) {
        return i;
      }
    }
    return -1;
  }

  // Land on an incomplete step and scroll to the first missing required field.
  private jumpToIncompleteStep(index: number) {
    this.isEdit = false;
    this.notFilesUploadedKeyNames = [];
    this.jobVolunteerDuplicateField = [];
    this.formName = this.dataStepSlugs[index];
    this.formPagination = index;
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    this.$nextTick(() => {
      this.$validator.validateAll().then(() => {
        setTimeout(() => {
          const invalid = document.getElementsByClassName("is-invalid")[0];
          if (invalid) {
            invalid.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }
        }, 100);
      });
    });
  }

  private validatorFieldCount(): number {
    try {
      const fields: any = (this.$validator as any).fields;
      return fields && fields.items ? fields.items.length : 0;
    } catch (e) {
      return 0;
    }
  }

  // Mark Basic Details (step 0) complete only when every required field
  // validates; unmark when a stale mark is left over. Runs only when step 0 is
  // rendered; validated silently.
  private async markStepZeroIfComplete() {
    if (this.formPagination !== 0 || this.validatorFieldCount() === 0) {
      return;
    }
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    const idx = this.formCompletedIndex.indexOf(0);
    if (valid && idx === -1) {
      this.formCompletedIndex.push(0);
    } else if (!valid && idx !== -1) {
      this.formCompletedIndex.splice(idx, 1);
    }
    localStorage.setItem(
      "trainingFormFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  // Take a step's completion back when it no longer validates. Marking stays
  // the exclusive job of Next, which also runs the custom checks (signature,
  // file uploads, duplicate emails) that vee-validate alone does not cover —
  // so this only ever removes a mark, never adds one. Without it, editing an
  // already-finished step and blanking a required field leaves the mark
  // standing and Preview still opens on the strength of it.
  private async unmarkStepIfIncomplete(step: number) {
    const idx = this.formCompletedIndex.indexOf(step);
    if (
      idx === -1 ||
      this.formPagination !== step ||
      this.validatorFieldCount() === 0
    ) {
      return;
    }
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    if (valid) {
      return;
    }
    this.formCompletedIndex.splice(idx, 1);
    localStorage.setItem(
      "trainingFormFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  // On load, re-derive step 0 completion once the tab has rendered.
  private async syncStepZeroOnLoad() {
    let tries = 0;
    while (
      tries++ < 30 &&
      (this.formData.length === 0 || this.validatorFieldCount() === 0)
    ) {
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    await this.markStepZeroIfComplete();
  }

  public nextPaginationUpdate() {
    if (this.formPagination < this.formData.length - 1) {
      this.isNavLoad = true;
      const page = this.formPagination + 1;
      if (page == 0) {
        this.formName = "certificationPartOneBasicDetails";
      } else if (page == 1) {
        this.formName = "trainingEducationExperience";
      } else if (page == 2) {
        this.formName = "trainingProgrammaticEligibilityQuestions";
      } else if (page == 3) {
        this.formName = "trainingJourneyofHeadling";
      } else if (page == 4) {
        this.formName = "trainingSignature";
      }
      this.formPagination = page;
    }
  }

  public async saveDraft() {
    // Save Draft is a deliberate save, so it reaches the server too - the
    // button says draft saved, and until now it only ever wrote this browser.
    this.persistDraft();
    this.$bvToast.show("example-toast");
    this.isValid = true;
    localStorage.setItem(
      "trainingFormPayload",
      JSON.stringify(this.payLoadData)
    );
    this.saveDataDraft = true;
    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public previousButton() {
    this.notFilesUploadedKeyNames = [];
    this.isEdit = false;
    if (this.formPagination !== 0) {
      const el = document.getElementById(this.mainId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.formPagination = this.formPagination - 1;
      if (this.formPagination == 0) {
        this.formName = "certificationPartOneBasicDetails";
      } else if (this.formPagination == 1) {
        this.formName = "trainingEducationExperience";
      } else if (this.formPagination == 2) {
        this.formName = "trainingProgrammaticEligibilityQuestions";
      } else if (this.formPagination == 3) {
        this.formName = "trainingJourneyofHeadling";
      } else if (this.formPagination == 4) {
        this.formName = "trainingSignature";
      }
    }
  }

  public onSubmit() {
    this.$validator.validate().then((validate) => {
      if (validate) {
        this.payLoadData.trainingSignature.submissionDate =
          moment().format("MM-DD-YYYY");
        let payloadStorage: any = localStorage.getItem("trainingFormPayload");
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.payLoadData = { ...payloadStorage };
        }
        this.isLoading = true;
        this.stopDraftAutoSave();
        this.payLoadData.fillStatus = "COMPLETED";
        if (
          this.payLoadData.certificationPartOneBasicDetails.secondaryEmail ===
          ""
        ) {
          this.payLoadData.certificationPartOneBasicDetails.secondaryEmail =
            null;
        }
        if (localStorage.getItem("trainingApplicationId")) {
          this.payLoadData.id = localStorage.getItem("trainingApplicationId");
        }
        const id = this.payLoadData.id;
        trainingFormApi
          .updateTrainingForm(
            this.payLoadData,
            id,
            this.currentRoute.split("/")[2]
          )
          .then(() => {
            trainingFormApi
              .getTrainingApplicationForm(id, this.currentRoute.split("/")[2])
              .then((result: any) => {
                localStorage.removeItem("anonymousToken");
                const applicationCode = result.data.code;
                const someData = {
                  title: "Certified Young Adult Peer Support Specialist",
                  SubTitle: "Training: Part One",
                };
                this.$router.push({
                  path: "/form/submitted",
                  query: {
                    subTitle: someData.SubTitle,
                    applicationId: applicationCode,
                  },
                });
                this.isLoading = false;
              })
              .catch((error) => {
                this.errorMessage = utils.errorMessage(error);
                this.isLoading = false;
              });
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
            localStorage.removeItem("trainingFormPayload");
            localStorage.removeItem("trainingApplicationId");
            localStorage.removeItem("trainingFormFilledIndex");
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      }
    });
  }

  public async navigateTab(slug: string, index: number) {
    if (index === this.formPagination) {
      return;
    }
    // Re-derive the step being left before the gate reads its mark. Jumping away
    // from an unfinished tab is allowed — it just does not get marked complete.
    if (this.formPagination === 0) {
      await this.markStepZeroIfComplete();
    } else {
      await this.unmarkStepIfIncomplete(this.formPagination);
    }
    if (index === this.dataStepSlugs.length) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    this.isEdit = false;
    this.notFilesUploadedKeyNames = [];
    this.jobVolunteerDuplicateField = [];
    this.persistDraft();
    this.formName = slug;
    this.formPagination = index;
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Draft saves are chained rather than fired in parallel: navigateTab does
  // not await this (the tab switches immediately), so jumping several tabs
  // quickly would otherwise leave overlapping PUTs racing, and whichever
  // response landed last would win regardless of the order they were sent.
  private draftSave: Promise<void> = Promise.resolve();

  /*
   * The local half on its own. Typing writes here and nowhere else: keystrokes
   * are not an instruction to save, and a request per field is both wasted and
   * a way for a half-typed value to be judged by the API before the applicant
   * has finished it. The server is written on the deliberate actions instead -
   * changing tab, Next, and Save Draft.
   */
  private saveDraftLocally() {
    localStorage.setItem(
      "trainingFormPayload",
      JSON.stringify(this.payLoadData)
    );
  }

  /*
   * The catch is what keeps this chain usable. Each save is appended to the
   * one before it, and Next awaits the chain before saving the step - so a
   * single rejected link leaves it permanently rejected, and every later
   * await throws inside an async handler with nowhere to report it. The
   * symptom is Next doing nothing at all, for the rest of the session.
   *
   * A draft save that fails is not worth stopping the applicant for: the
   * local copy holds their work and Next saves the step itself.
   */
  public persistDraft(): Promise<void> {
    this.draftSave = this.draftSave
      .then(() => this.saveDraftNow())
      .catch(() => undefined);
    return this.draftSave;
  }

  /*
   * Wait for an in-flight draft save, but not forever. Without a bound, a
   * request that never answers holds Next open indefinitely with the loader
   * showing and no way out. The wait only exists so Next updates the row the
   * autosave created rather than creating a second one; if it has not
   * finished by now, going ahead is better than stranding the applicant.
   */
  private waitForDraftSave(): Promise<void> {
    return Promise.race([
      this.draftSave,
      new Promise<void>((resolve) => setTimeout(resolve, 8000)),
    ]).then(() => undefined);
  }

  /**
   * Store the draft. The local copy is written unconditionally, so progress
   * survives a reload from the very first field the applicant fills.
   *
   * The server copy needs an email: fetchDetailsfromData() in the workflow API
   * keys the row on it (and rejects the save without a valid one), so the row is
   * created the moment a valid email exists and updated on every save after
   * that. Before then the draft is local-only, which is silent by design — the
   * applicant has not given us anything to file it under yet, so a failed save
   * is not something they can act on.
   */
  private async saveDraftNow() {
    localStorage.setItem(
      "trainingFormPayload",
      JSON.stringify(this.payLoadData)
    );
    const basicDetails = this.payLoadData.certificationPartOneBasicDetails;
    if (!this.payLoadData.id) {
      if (!utils.canSaveDraftRemotely(basicDetails.email)) {
        return;
      }
      try {
        const result: any = await trainingFormApi.TrainingApplicationForm(
          this.payLoadData.fillStatus,
          this.payLoadData,
          this.currentRoute.split("/")[2]
        );
        this.formApplicationId = result.headers.location;
        localStorage.setItem("trainingApplicationId", this.formApplicationId);
        this.payLoadData.id = this.formApplicationId;
        localStorage.setItem(
          "trainingFormPayload",
          JSON.stringify(this.payLoadData)
        );
      } catch (error) {
        // Kept quiet: an autosave the applicant did not ask for should not throw
        // a popup over the field they are typing in. The local copy above still
        // holds everything, and Next surfaces the real error when they submit.
      }
      return;
    }
    try {
      await trainingFormApi.updateTrainingForm(
        this.payLoadData,
        this.payLoadData.id,
        this.currentRoute.split("/")[2]
      );
    } catch (error) {
      this.errorMessage = utils.errorMessage(error);
    }
  }

  // Debounced autosave, armed once the form has finished loading so the CMS
  // render and the applicant prefill do not count as filling anything in. From
  // the first real keystroke every change is persisted.
  private draftAutoSaveTimer: any = null;

  private queueDraftSave() {
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
    }
    this.draftAutoSaveTimer = setTimeout(() => {
      this.draftAutoSaveTimer = null;
      this.saveDraftLocally();
    }, 1000);
  }

  private draftWatchStop: any = null;

  private startDraftAutoSave() {
    this.draftWatchStop = this.$watch(
      "payLoadData",
      () => {
        // Errors are raised by an action - Next, or the bounce to an
        // incomplete step - and dismissed the moment the applicant starts
        // answering them. Without this the gate stays open after a failed
        // Next and vee-validate re-runs on every keystroke, so typing an
        // email is marked invalid letter by letter until it happens to be
        // complete. They are shown again by the next Next.
        this.checkValidForm = false;
        this.queueDraftSave();
      },
      { deep: true }
    );
  }

  /*
   * Submitting ends the draft. The payload is still mutated on the way out -
   * fillStatus, the signature date, the id read back from storage - and each
   * of those fires the watcher above, queueing a local write. onSubmit then
   * clears the stored draft, and the queued write lands a second later and
   * puts it straight back, so the next application opens on the submitted
   * one's data. Stop the watcher and drop anything pending before the submit
   * runs, so no write can outlive it.
   */
  private stopDraftAutoSave() {
    if (this.draftWatchStop) {
      this.draftWatchStop();
      this.draftWatchStop = null;
    }
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
      this.draftAutoSaveTimer = null;
    }
  }

  public beforeDestroy() {
    this.stopDraftAutoSave();
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public emptyEvent() {
    return;
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public addNameBox(formName: string) {
    this.additionalNamesCount++;
    if (this.payLoadData[formName].names.length) {
      this.payLoadData[formName].names.push("");
    } else {
      this.payLoadData[formName].names = [""];
    }
  }

  public fieldUpdate(groupName = "", initial = false) {
    switch (groupName) {
      case "isOtherName":
        if (
          !this.payLoadData.certificationPartOneBasicDetails.isOtherName ||
          this.payLoadData.certificationPartOneBasicDetails.isOtherName === "No"
        ) {
          if (!this.hideDiv.includes("allVersionNames") && !initial) {
            this.hideDiv.push("allVersionNames");
            this.payLoadData.certificationPartOneBasicDetails.allVersionNames =
              [];
          } else {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("allVersionNames") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("allVersionNames"), 1);
          }
        }
        break;
      case "highSchool":
        if (
          !this.payLoadData.trainingEducationExperience.highSchool.includes(
            "Other"
          )
        ) {
          if (!this.hideDiv.includes("highSchoolNotListed") && !initial) {
            this.hideDiv.push("highSchoolNotListed");
            this.payLoadData.trainingEducationExperience.highSchoolNotListed =
              "";
          } else {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("highSchoolNotListed") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("highSchoolNotListed"), 1);
          }
        }
        break;
      case "otherCertifications":
        if (
          !this.payLoadData.trainingEducationExperience.otherCertifications.includes(
            "CPRS"
          )
        ) {
          if (!this.hideDiv.includes("cprsCertificate") && !initial) {
            this.hideDiv.push("cprsCertificate");
            this.payLoadData.trainingEducationExperience.cprsCertificate = [];
          }
        } else {
          if (this.hideDiv.indexOf("cprsCertificate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("cprsCertificate"), 1);
          }
        }
        if (
          !this.payLoadData.trainingEducationExperience.otherCertifications.includes(
            "CFSS"
          )
        ) {
          if (!this.hideDiv.includes("cfssCertificate") && !initial) {
            this.hideDiv.push("cfssCertificate");
            this.payLoadData.trainingEducationExperience.cfssCertificate = [];
          }
        } else {
          if (this.hideDiv.indexOf("cfssCertificate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("cfssCertificate"), 1);
          }
        }
        if (
          !this.payLoadData.trainingEducationExperience.otherCertifications.includes(
            "Other"
          )
        ) {
          if (!this.hideDiv.includes("otherCertificate") && !initial) {
            this.hideDiv.push("otherCertificate");
            this.payLoadData.trainingEducationExperience.otherCertificate = [];
          }
        } else {
          if (this.hideDiv.indexOf("otherCertificate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("otherCertificate"), 1);
          }
        }
        break;
      case "trainingCity":
        if (
          !this.payLoadData.certificationPartOneBasicDetails.trainingCity.includes(
            "Other"
          )
        ) {
          if (!this.hideDiv.includes("otherTrainingCity") && !initial) {
            this.hideDiv.push("otherTrainingCity");
            this.payLoadData.certificationPartOneBasicDetails.otherTrainingCity =
              "";
          } else {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("otherTrainingCity") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("otherTrainingCity"), 1);
          }
        }
        break;
      default:
        break;
    }
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
  public goBack() {
    if (this.$route.query.isDraft) {
      localStorage.removeItem("trainingFormPayload");
      localStorage.removeItem("trainingFormFilledIndex");
    }
    this.$router.push({
      path: `/application`,
      query: {
        form: "training",
      },
    });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
  }
}
